import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';
import type { MEMBERSHIP_MODELS } from '@r-and-a-shared-ui/common-kontent-client';

export default {
  component: undefined,
  mapEntryToProps: (entry: MEMBERSHIP_MODELS.ArticleAuthor) =>
    kontentAiDataMapping.article_author(entry),
};
